module.exports = __webpack_public_path__ + "static/media/latam-regional.4459d315.png";